export default __webpack_public_path__ + "refine-on-phone-ec312b0ac3119bb50c6d7af203bf983a.digested.png";